import { Component, OnInit, Input, Output, EventEmitter, Directive } from '@angular/core';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { DocumentElement } from '../interfaces';
import { DocumentsService } from '../../services/documents-service/documents-pro.service';

@Component({
  selector: 'mcrit-gestio-document',
  templateUrl: 'documents.component.html',
  styleUrls: [ 'documents.component.css' ],
  providers: [ DocumentsService ]
})

export class DocumentsComponent implements OnInit {
  @Input() tipus: string = '';
  @Input() codi: string = '';

  public availableDocuments: Array<DocumentElement> = [];
  public error: boolean = false;
  public showAsyncProgress: boolean = false;

  public newDocument: DocumentElement = {
    id: '',
    codi: '',
    tipus: '',
    descripcio: '',
    fitxer: '',
    nota: '',
    file: null
  };

  public updateDocument(i: number): void {
   const document = this.availableDocuments[i];
  
   if (!document.file) return;

   this.showAsyncProgress = true;
   let observable;

   if (document.id === 'NEW') {
    observable = this.documentService.createDocument(document);
   } else {
    observable = this.documentService.updateDocument(document);
   } 

   // EXECUTAR LA CRIDA
   observable.subscribe({
    next: (updatedRecord) => {
      console.log('Document guardat correctament', updatedRecord);
      this.showAsyncProgress = false;
      
      // Opcional: Actualitzar l'ID si era nou o recarregar la llista
      if (document.id === 'NEW' && updatedRecord.id) {
        document.id = updatedRecord.id;
        document.fitxer = updatedRecord.fitxer;
      }
    },
    error: (err) => {
      console.error('Error al guardar', err);
      this.showAsyncProgress = false;
      this.error = true;
    }
   });
  }

  public deleteDocument(i: number) {
    const document = this.availableDocuments[i];
  
    // Si és un document nou que encara no s'ha guardat, només l'eliminem de l'array local
    if (document.id === 'NEW') {
      this.availableDocuments.splice(i, 1);
      return;
    }

    this.showAsyncProgress = true;
    this.documentService.deleteDocument(document.id).subscribe({
      next: () => {
        this.availableDocuments.splice(i, 1); // Eliminar de la llista visual
        this.showAsyncProgress = false;
      },
      error: (err) => {
        console.error('Error al eliminar', err);
        this.showAsyncProgress = false;
      }
    });
  }

  public onFileChange(event) {
    let reader = new FileReader();

    if(event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        if(file.size > 100000000){
          alert("Limit del fitxer a pujar 100Mb!");
          this.newDocument.fitxer = '';
          return;
        };
        this.newDocument.fitxer = file.name;
        this.newDocument.file = {
          filename: file.name,
          filetype: file.type,
          value: reader.result
        };
        this.newDocument.id = 'NEW'
        this.newDocument.codi = this.codi;
        this.newDocument.tipus = this.tipus;
        this.availableDocuments.push(Object.assign({}, this.newDocument));
      };
    }else {this.newDocument.file = null;this.newDocument.fitxer = '';}
  }

  constructor(public translate: TranslateService, public languageService: LanguageService, protected documentService: DocumentsService){}

  ngOnInit(){
    this.documentService.getActive(this.codi, this.tipus)
      .subscribe(documents => { 
        this.availableDocuments = documents.rows;
        this.showAsyncProgress = false; 
      });
    this.newDocument.codi = this.codi;
  }
}
